import '@webmotors/consumer-shared-ui/styles.css';
import '@/styles/globals.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ObservabilityErrorBoundary, exposeBuildVersion } from '@/services/observability';
import { App } from '@/App';

exposeBuildVersion();

const rootElement = document.getElementById('root');

if (!rootElement) {
	throw new Error('Root element not found. Ensure index.html has a <div id="root"></div>.');
}

createRoot(rootElement).render(
	<StrictMode>
		<ObservabilityErrorBoundary>
			<App />
		</ObservabilityErrorBoundary>
	</StrictMode>
);
